export default [
  '/about',
  '/resources',
];
